import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function HorseTraitsDialog({ horse, onClose }) {
  const dialog = useRef(null);
  useEffect(() => {
    const element = dialog.current, previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    element.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      if (element.open) element.close();
      document.body.style.overflow = previousOverflow;
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, []);

  return createPortal(<dialog className="hc-traits-dialog" ref={dialog} aria-labelledby="hc-traits-title" onCancel={e => { e.preventDefault(); onClose(); }} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
    <div className="hc-popup-panel">
      <header className="hc-popup-header"><div><h3 id="hc-traits-title">{horse.horse_no} {horse.name} ｜ 強み・注意点</h3><p>判定の根拠・参考情報</p></div><button type="button" autoFocus aria-label="ポップアップを閉じる" onClick={onClose}>×</button></header>
      <div className="hc-popup-body">{(horse.traits || []).map((tag, i) => <article key={i}><span className={`hc-tag hc-${tag.kind}`}>{tag.kind === 'strong' ? '＋ ' : '！ '}{tag.label}</span><p>{tag.reason}</p></article>)}</div>
    </div>
  </dialog>, document.body);
}
